<template>
  <div class="micro-chart-cell">
    <div class="wrapper">
      <component
        :is="component"
        v-if="component"
        :data="data"
        :fixed-tooltip="fixedTooltip"
      />
    </div>
  </div>
</template>

<script>
import MicroBars from './microcharts/MicroBars.vue'
import MicroHistogram from './microcharts/MicroHistogram.vue'
import MicroList from './microcharts/MicroList.vue'
import MicroPie from './microcharts/MicroPie.vue'
import MicroUnique from './microcharts/MicroUnique.vue'
import MicroSingle from './microcharts/MicroSingle.vue'

export default {
  props: ['data', 'fixedTooltip'],

  mouted() {},
  computed: {
    dataType() {
      return this.data.type
    },
    // chartData(){
    //   return this.data.values || this.data.buckets
    // },
    component() {
      if (this.dataType === 'text') {
        if (this.data.unique === 1) return MicroSingle
        else if (this.data.unique < 5) return MicroPie
        else if (this.data.unique < 11) return MicroBars
        else return MicroList
      } else if (this.dataType === 'num') {
        if (this.data.buckets.length === 1) return MicroSingle
        else return MicroHistogram
      } else {
        return MicroUnique
      }

    },
  },
}
</script>

<style lang="stylus" scoped>
.micro-chart-cell
  .table-wrapper &
    m-font-size(13)

    .wrapper
      overflow: hidden
      margin: vw(8px) vw(15px) 0

  .wrapper
    position: relative
    height: 100%

    >>> .tooltip
      position: absolute
      padding: vw(6px)
      border: solid 1px #ddd
      border-radius: vw(6px)
      background: #fff
      pointer-events: none

      .value
        font-weight: bold

      .label
        color: #696973

        .count
          font-weight: bold

      &.fade-enter-active,
      &.fade-leave-active
        transition: opacity 0.5s ease

      &.fade-enter-from,
      &.fade-leave-to
        opacity: 0

    >>> svg
      margin: auto

      .item
        transition: opacity 0.4s

        // transition-delay .2s
        &.innactive
          opacity: 0.2
          // transition-delay 0
</style>
